module.exports = __webpack_public_path__ + "img/phone.c3dc0680.svg";